module.exports = __webpack_public_path__ + "static/img/airline.313549dd.png";